import React from 'react';
import { parse } from 'query-string';
import pick from 'lodash/pick';
import find from 'lodash/find';
import defaults from 'lodash/defaults';
import mapValues from 'lodash/mapValues';
import isArray from 'lodash/isArray';
import { hideMap, SET_PAGE_SEARCH_RESULTS, updateSearchFilters as setSearchFilters } from '../../actions';
import rootSaga from '../../sagas';
import FilterBar from '../../components/SearchFilter/FilterBar';
import ListingResults from '../../components/Listings/Results';
import Map from '../../components/Map';
import coordinatesOverrides from '../../../../../../config/coordinates_overrides.json';
import { MediaContextProvider, mediaStyle as mediaQueryCSS } from '../../helpers/MediaQuery';

export const SCOPED_REDUCERS = ['searchFilters', 'map', 'searchResults'];

export const router = {
  type: 'BrowserRouter',
};

export const prepare = async ({ store, window }) => {
  const task = store.runSaga(rootSaga);

  if (window.shouldHideMap) {
    store.dispatch(hideMap());
  }

  // all duplicate parameters are transformed into an array field
  // ex: position_types: [ 'BASEMENT', 'GROUND_FLOOR_STREET' ]
  const queryParameters = parse(window.url.replace(/\/search\?/, ''), {
    parseNumbers: true,
    parseBooleans: true,
    arrayFormat: 'none',
  });

  // Here, we override the bounding box coordinates returned by google if the are not ideal
  // Ex: For UK, the bounding box is so wide it would includes Paris too.
  const coordinatesOverride = find(coordinatesOverrides, { address: queryParameters.address }) || {};

  let urlParams = defaults(coordinatesOverride, window.searchCoreMarket || {}, queryParameters);

  // These fields need to be in an array format so if they are unique we insert them into an array
  const DUPS = ['position_types', 'space_type_ids', 'listing_feature_ids'];

  urlParams = mapValues(urlParams, (value, key) => (DUPS.includes(key) && !isArray(value) ? [value] : value));

  store.dispatch({
    type: 'SET_MAP_VIEWPORT',
    payload: {
      longitude: urlParams.longitude,
      latitude: urlParams.latitude,
      zoom: urlParams.zoom || 11,
      transitionDuration: 0,
    },
  });

  store.dispatch(setSearchFilters(urlParams));
  store.dispatch({ type: SET_PAGE_SEARCH_RESULTS, payload: 1 });
  store.close();

  await task.toPromise();

  const staticMapBoundingBox = !window.shouldHideMap && pick(urlParams, [
    'latitude', 'longitude', 'zoom',
    'lng_g', 'lng_l', 'lat_g', 'lat_l', // Shorthand url coordinates keys
    'latitude_lteq', 'latitude_gteq', 'longitude_lteq', 'longitude_gteq', // core market coordinates from core_markets.json if window.searchCoreMarket is set (Ex: /search/new-york)
  ]);

  return {
    mediaQueryCSS,
    staticMapBoundingBox,
  };
};

export function RootComponent() {
  return (
    <MediaContextProvider disableDynamicMediaQueries>
      <FilterBar />
      <ListingResults />
      <Map />
    </MediaContextProvider>
  );
}
